import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import { PulseLoader } from "halogen";
import { Field, reduxForm, SubmissionError, getFormValues } from "redux-form";
import * as MabnaButton from "../../Button/Button";
import { NotificationManager } from "react-notifications";

import { isEmptyObject } from "../../../../helpers/utility";
import { FETCH_GRADES_REQUEST } from "../../../../actions/actions";
import { appendToFormData } from "../../../../helpers/utility";
import { flattenArray } from "../../../../helpers/utility";

import importStudentsSelectors from "../../../../selectors/importStudentSelector";

import {
  IMPORT_STUDENTS_REQUEST,
  FETCH_ACADEMIC_YEARS_REQUEST,
  FETCH_SCHOOL_STUDENTS_REQUEST
} from "../../../../actions/actions";
import UploadedStudentsTable from "../../../school/UploadedStudentsTable";

const styles = {
  dropzone: {
    cursor: "pointer",
    width: "100%",
    height: "auto",
    padding: 10,
    border: "3px dashed #00abde",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  }
};

const getStudentsWithErrorCount = (students = []) =>
  students.filter(s => !s.successful).length;

class AddStudentsFromExcel extends Component {
  constructor() {
    super();
    this.state = {
      fileError: null,
      badFileType: false,
      isOpen: false,
      displayIgnoreErrorsButton: false
    };
  }

  componentWillMount() {
    if (isEmptyObject(this.props.grades)) {
      const { dispatch } = this.props;
      dispatch({ type: FETCH_GRADES_REQUEST });
    }

    if (isEmptyObject(this.props.academicYears)) {
      const { dispatch } = this.props;
      dispatch({ type: FETCH_ACADEMIC_YEARS_REQUEST });
    }
  }

  componentDidMount() {
    if (this.props.notCollapsedInitially) {
      this.setState({ isOpen: true });
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.isOpen !== null && nextProps.isOpen !== undefined) {
      this.setState({ isOpen: nextProps.isOpen });
    }
  };

  // selectGrade = ({ input, meta: { touched, error }, grades, allowedGrades }) => {
  //   const gradesToShow = allowedGrades || grades

  //   return (
  //     <div>
  //       <div>پایه تحصیلی</div>

  //       {touched && error && <div className="form-error">{error}</div>}

  //       <select {...input}>
  //         <option value="-1" />
  //         {gradesToShow.map((grade, i) => (
  //           <option key={i} value={grade.id}>
  //             {grade.name}
  //           </option>
  //         ))}
  //       </select>
  //     </div>
  //   )
  // }

  // selectAcademicYears = ({
  //   input,
  //   label,
  //   type,
  //   meta: { touched, error, warning },
  //   academicYears
  // }) => {
  //   return (
  //     <div>
  //       <div>
  //          عضویت برای سال تحصیلی
  //       </div>
  //       {touched && error && <div className="form-error">{error}</div>}
  //       <select {...input}>
  //         {academicYears.map((academicYear, i) =>
  //           <option key={i} value={academicYear.id}>{academicYear.name}</option>
  //         )}
  //       </select>
  //     </div>
  //   );
  // };

  shouldDisplayIgnoreErrorsButton = () => this.state.displayIgnoreErrorsButton;

  showIgnoreErrorsButton = () =>
    this.setState({ displayIgnoreErrorsButton: true });

  hideIgnoreErrorsButton = () =>
    this.setState({ displayIgnoreErrorsButton: false });

  renderDropzone = field => {
    const file = field.input.value;

    const excelFileMIMEType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

    const dropzoneProps = {
      name: field.name,
      multiple: false,
      disablePreview: true,
      id: "student-dropzone",
      style: styles.dropzone,
      accept: excelFileMIMEType,
      activeClassName: "dorpzone-ok",
      rejectClassName: "dorpzone-error",
      className: this.getDropZoneClassName(),
      onDrop: files => field.input.onChange(files[0])
    };

    const showErrors = field.meta.error && field.meta.touched;

    return (
      <Dropzone {...dropzoneProps}>
        <strong>عضویت دانش آموزان بصورت گروهی از فایل اکسل</strong>

        <span>(میتوانید فایل را درون این ناحیه رها کنید)</span>
        {showErrors && <span style={{ color: "red" }}>{field.meta.error}</span>}
        {file && file.name}
      </Dropzone>
    );
  };

  getSchoolId = () =>
    this.props.params ? this.props.params.schoolId : this.props.schoolId;

  // submitIgnoreErrors = (formValues) => {
  //   return this.onSubmit(formValues)
  // }

  onSubmit = values => {
    const formData = appendToFormData(values);
    const ignored_errors = values.ignore_errors === true;
    const schoolId = this.getSchoolId();

    return new Promise((resolve, reject) => {
      this.props.dispatch({
        type: IMPORT_STUDENTS_REQUEST,
        formData,
        resolve,
        reject
      });
    })
      .then(({ students, studentsData, successful }) => {
        // this.props.dispatch({ type: FETCH_SCHOOL_STUDENTS_REQUEST, schoolId })
        this.hideIgnoreErrorsButton();
        const studentsWithError = getStudentsWithErrorCount(students);

        if (successful) {
          NotificationManager.success(
            "فایل دانش آموزان با موفقیت به عضویت سامانه در آمدند. ",
            null,
            6000
          );
        } else {
          NotificationManager.error(
            `خطا در اطلاعات ${studentsWithError} دانش‌آموز`,
            null,
            6000
          );
        }

        if (
          !successful &&
          students.length > 0 &&
          studentsWithError > 0 &&
          students.length - studentsWithError > 0
        ) {
          this.showIgnoreErrorsButton();
        } else {
          this.hideIgnoreErrorsButton();
        }

        this.props.onAddSuccess &&
          this.props.onAddSuccess(studentsData, ignored_errors);
      })
      .catch(({ general_errors, form_errors }) => {
        const errors = [
          ...flattenArray(general_errors),
          ...this.handleFormErrors(form_errors)
        ];

        general_errors.length === 0
          ? this.showIgnoreErrorsButton()
          : this.hideIgnoreErrorsButton();

        throw new SubmissionError({
          _error: errors
        });
      });
  };

  handleFormErrors = formErrors =>
    // object with excel rows as it's keys
    Object.keys(formErrors).map(
      excelRow =>
        `خطا در ردیف - ${excelRow}: ${flattenArray(formErrors[excelRow]).join(
          ". "
        )}`
    );

  getDropZoneClassName = () => {
    if (this.props.dropzoneStatus === "accepted") {
      return "dropzone-ok";
    }

    const rejected =
      this.state.fileError ||
      this.state.badFileType ||
      this.state.dropzoneStatus === "rejected";

    if (rejected) {
      return "dropzone-error";
    }

    return "";
  };

  render() {
    const { handleSubmit, error, students, aSyncCall } = this.props;
    if (!this.state.isOpen) return <div />;

    const studentsWithError = getStudentsWithErrorCount(students);

    return (
      <div id="school-student-manager">
        <div
          id="student-import-section"
          className={this.props.stackVertically && "stack-vertically"}
        >
          <div className="right-side">
            <form onSubmit={handleSubmit(this.onSubmit)}>
              <Field name="excel" component={this.renderDropzone} />

              {/*<div>
                  <strong>
                    در صورتی که دانش آموز از قبل در سیستم ثبت شده بود:
                  </strong>
                </div>

                <Field name="action" component={RadioButtonGroup}>
                  <RadioButton value="skip" label="صرف نظر شود" />
                  <RadioButton value="error" label="اخطار داده شود" />
                  <RadioButton value="add" label="به مدرسه اضافه شود" />
                </Field> */}

              {/* <Field
                  component={this.selectGrade}
                  name="grade"
                  grades={this.props.grades}
                  allowedGrades={this.props.allowedGrades}
                /> */}

              {/* <div className="form-warning">
                  درصورتی که پایه تحصیلی دانش آموزان در فایل اکسل موجود باشد نیازی به پر
                  کردن این گزینه در فرم نیست
                </div> */}

              {/*<Field
                  component={this.selectAcademicYears}
                  name="academic_year"
                  academicYears={this.props.academicYears}
                />*/}

              {!this.props.studentUpload ? (
                <div>
                  <div>
                    {/* عضویت در سامانه */}
                    {aSyncCall ? (
                      <PulseLoader color="#275C8A" size="10px" />
                    ) : (
                      <MabnaButton.Primary outline type="submit">
                        بررسی فایل بارگزاری شده
                      </MabnaButton.Primary>
                    )}

                    {this.shouldDisplayIgnoreErrorsButton() && (
                      <MabnaButton.Warning
                        onClick={handleSubmit(values =>
                          this.onSubmit({
                            ...values,
                            ignore_errors: true
                          })
                        )}
                        style={{ marginRight: 10 }}
                      >
                        صرف نظر از خطاها و ادامه
                      </MabnaButton.Warning>
                    )}
                  </div>
                  {(students && students.length > 0) && (
                    <div className="uploaded-students-stats">
                      <div className="error">
                        <span className="key">{`تعداد خطاها: `}</span>
                        <span className="value">{studentsWithError}</span>
                      </div>
                      <div className="success">
                        <span className="key">{`تعداد دانش‌آموزان بدون خطا: `} </span>
                        <span className="value">{students.length - studentsWithError}</span>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <PulseLoader color="#275C8A" size="10px" />}
                </div>
              )}
            </form>
          </div>

          {/* this.props.students is the same as importedStudents is injected from store */}
          <div className="left-side">
            {students && students.length > 0 && (
              <UploadedStudentsTable students={students} />
            )}

            <div>
              <div className="form-error">
                {error && (
                  <ul>
                    {error.map((errText, i) => (
                      <li key={i}>{errText}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = values => {
  let errors = {};

  if (!values.excel) {
    errors.excel = "فایل اکسل لازم است ";
  }

  return errors;
};

AddStudentsFromExcel = reduxForm({
  form: "AddStudentsFromExcel",
  validate
})(AddStudentsFromExcel);

function mapStateToProps(state) {
  return {
    ...importStudentsSelectors(state),
    grades: state.grades,
    academicYears: state.academicYears,

    formValues: getFormValues("AddStudentsFromExcel")
    // action: "add",
    // academic_year: 1
    // }
  };
}

export default connect(mapStateToProps)(AddStudentsFromExcel);



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/AddStudentsFromExcel.js